export function formatEventName(input: string | number): string {
  return input
    .toString()
    .trim() // Trim whitespace from both ends
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/\./g, "-"); // Replace dots with hyphens
}
